import { IconCircle, IconCircleFilled } from "@tabler/icons-react";
import { msg } from "@lingui/macro";
import { useLingui } from "@lingui/react";
import type { MessageDescriptor } from "@lingui/core";

import { cx } from "./cx";
import styles from "./DifficultyMeter.module.css";

const ICON_SIZE = 13;
const LEVELS = [1, 2, 3] as const;

const difficultyLabels: Record<number, MessageDescriptor> = {
  1: msg`Лёгкий`,
  2: msg`Средний`,
  3: msg`Сложный`,
};

export interface DifficultyMeterProps {
  difficulty: number;
  className?: string;
}

export function DifficultyMeter({ difficulty, className }: DifficultyMeterProps): JSX.Element {
  const { i18n } = useLingui();
  const clamped = Math.min(3, Math.max(1, difficulty));
  const label = difficultyLabels[clamped];
  return (
    <span className={cx(styles.meter, className)}>
      <span className={styles.dots} aria-hidden="true">
        {LEVELS.map((level) =>
          level <= clamped ? (
            <IconCircleFilled key={level} size={ICON_SIZE} className={styles.on} />
          ) : (
            <IconCircle key={level} size={ICON_SIZE} className={styles.off} />
          ),
        )}
      </span>
      <span className={styles.text}>
        {label ? i18n._(label) : ""} · {clamped}/3
      </span>
    </span>
  );
}
